import {ALERT_TYPES, DEFAULT_ERROR_MESSAGE} from "./Constants";

export function getNodeId() {
    let params = new URLSearchParams(window.location.search);
    return params.get('stationCode');
}

export function getErrorAlertObjectFromResponse(response) {
    if (response.data && response.data.message) {
        const message = response.data.message;
        const truncated_message = (message.length > 300) ? message.substr(0, 300) + '...' : message;
        const error_text = "ERROR : " + truncated_message;
        return {visible: true, text: error_text, type: ALERT_TYPES.ERROR};
    }
    return {visible: true, text: DEFAULT_ERROR_MESSAGE, type: ALERT_TYPES.ERROR};
}



// WEBPACK FOOTER //
// ./src/Utils.js